import { Button } from '@positivote/design-system/components/Button'
import { Div } from '@positivote/design-system/components/Div'
import { Typography } from '@positivote/design-system/components/Typography'
import { useNavigate } from 'react-router-dom'

import { Error404 } from '@/common/assets/images'
import { changePageTitle } from '@/common/helpers'
import { i18n } from '@/common/i18n'
import { BaseBackground } from '@/common/layouts'

export function NotFound(): JSX.Element {
  changePageTitle(i18n().common.pages.notFound.title)
  const navigate = useNavigate()

  return (
    <BaseBackground footer={false}>
      <Div
        css={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          height: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '$lg',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          margin: '$lg auto'
        }}
      >
        <Error404 />
        <Div css={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '$2xs' }}>
          <Typography variant="headlineMedium" css={{ color: '$on-surface' }}>
            {i18n().common.pages.notFound.message}
          </Typography>
          <Typography variant="bodyMedium" css={{ color: '$on-surface-variant' }}>
            {i18n().common.pages.notFound.verifyTypedAddress}
          </Typography>
        </Div>
        <Button variant="filled" onClick={() => navigate('/')}>
          {i18n().common.pages.notFound.buttons.goBack}
        </Button>
      </Div>
    </BaseBackground>
  )
}
